import { el, setChildren } from 'redom';

import {
  convertSecondsToDisplayFormat
} from '../utilities';

import './index.scss';

class PlayerDuration {

  constructor(videoBuilder) {

    this.videoBuilder = videoBuilder;
    this.timeElapsed = 0;

    this.timeElapsedView = el('div.video-builder-duration-time-elapsed', '00:00');
    this.timeTotalView = el('div.video-builder-duration-time-total', convertSecondsToDisplayFormat(this.videoBuilder.playerProperties.durationInSeconds));
    this.timeTotalInput = el('input.video-builder-duration-time-input', {
      type: 'number',
      value: this.videoBuilder.playerProperties.durationInSeconds,
      min: 10,
      max: 999999,
      oninput: (e) => {
        this.videoBuilder.playerProperties.durationInSeconds = +e.target.value;
        this.videoBuilder.tracks.update();
        this.timeTotalView.textContent = convertSecondsToDisplayFormat(this.videoBuilder.playerProperties.durationInSeconds);
        this.videoBuilder.updateProperties({ player: structuredClone(this.videoBuilder.playerProperties) });
      }
    });
    this.timeTotalInputContainer = el('.video-builder-duration-time-total-input-container', [
      this.timeTotalInput,
      el('span', 'sec')
    ]);
    this.timeTotalContainer = el('.video-builder-duration-time-total-container', {
      onmouseenter: () => {
        setChildren(this.timeTotalContainer, [this.timeTotalInputContainer]);
        this.timeTotalInput.focus();
      },
      onmouseleave: () => {
        setChildren(this.timeTotalContainer, [this.timeTotalView]);
      }
    }, [
      this.timeTotalView
    ]);
    this.el = el('.video-builder-duration', [
      this.timeElapsedView,
      el('div', '/'),
      this.timeTotalContainer,
    ]);

  }

  update(timeElapsed) {

    this.timeElapsed = timeElapsed;
    this.timeElapsedView.textContent = convertSecondsToDisplayFormat(timeElapsed);
    this.timeTotalInput.value = this.videoBuilder.playerProperties.durationInSeconds;

  }

}

export default PlayerDuration;